/**
 * Props for the DocumentUploadIconWithBgColor component.
 */
interface DocumentUploadIconWithBgColorProps {
  /** Background fill color for the icon container. @default "#E6F3F0" */
  fillColor?: string;
  /** Stroke color for the document and upload arrow. @default "#005D49" */
  strokeColor?: string;
  /** Width of the SVG element. @default "22" */
  width?: string;
  /** Height of the SVG element. @default "22" */
  height?: string;
}

/**
 * A document upload icon with a customizable colored background.
 * Renders an SVG icon representing a document with an upward arrow,
 * indicating file upload functionality.
 *
 * @param props - The component props
 * @returns A styled SVG document upload icon with rounded background
 *
 * @example
 * ```tsx
 * // Default styling (light teal background with dark teal icon)
 * <DocumentUploadIconWithBgColor />
 *
 * // Custom colors
 * <DocumentUploadIconWithBgColor
 *   fillColor="#E6E6FA"
 *   strokeColor="#4B0082"
 *   width="28"
 *   height="28"
 * />
 * ```
 */
const DocumentUploadIconWithBgColor = (
  props: DocumentUploadIconWithBgColorProps,
) => {
  return (
    <svg
      width={props.width ?? "22"}
      height={props.height ?? "22"}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" rx="4" fill={props.fillColor ?? "#E6F3F0"} />
      <path
        d="M12.5295 3.56917V6.72445C12.5295 7.15227 12.5295 7.36617 12.6128 7.52958C12.686 7.67331 12.8029 7.79017 12.9466 7.86341C13.11 7.94667 13.3239 7.94667 13.7517 7.94667H16.907M12.5295 3.36328H8.55729C7.27384 3.36328 6.63211 3.36328 6.1419 3.61306C5.71069 3.83277 5.36011 4.18335 5.1404 4.61455C4.89062 5.10477 4.89062 5.74649 4.89062 7.02995V14.9744C4.89062 16.2578 4.89062 16.8996 5.1404 17.3898C5.36011 17.821 5.71069 18.1716 6.1419 18.3913C6.63211 18.6411 7.27384 18.6411 8.55729 18.6411H13.4462C14.7296 18.6411 15.3714 18.6411 15.8616 18.3913C16.2928 18.1716 16.6434 17.821 16.8631 17.3898C17.1128 16.8996 17.1128 16.2578 17.1128 14.9744V7.94662L12.5295 3.36328Z"
        stroke={props.strokeColor ?? "#005D49"}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.71094 13.2923L11.0026 11.0007M11.0026 11.0007L13.2943 13.2923M11.0026 11.0007L11.0026 15.584"
        stroke={props.strokeColor ?? "#005D49"}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DocumentUploadIconWithBgColor;
